import { render, staticRenderFns } from "./koejakso-tavoitteet.vue?vue&type=template&id=5fb09e50&"
import script from "./koejakso-tavoitteet.vue?vue&type=script&lang=ts&"
export * from "./koejakso-tavoitteet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports